var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"text":"","icon":"mdi-information-outline"}},[_c('span',{staticClass:"ml-4"},[_vm._v(" Die Heatmap-Ansicht ist aktiv. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }